import DtoUserStatistic from './DtoUserStatistic'

export default class DtoUserStationStatistic extends DtoUserStatistic {
    constructor(obj) {
        super(obj)
    }
}